@if (condition) {
  <div class="carrier-condition-editor" [formGroup]="detailsFormGroup">
    <div class="row">
      <mat-form-field class="flex-grow" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.carrier"></sc-dictionary-label>
        </mat-label>
        <input matInput formControlName="carrier" name="carrier" maxlength="255"
          [maxlength]="255">
        </mat-form-field>
      </div>
    </div>
  }
